export const getSycurioPageHeight = (
  sycurioEventData: string,
): string => {
  const { data } = JSON.parse(sycurioEventData);
  const { pageHeight } = data;
  return pageHeight ?? '';
};
